import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/combineLatest';
import { UPDATE_SUGGESTED_KEY } from '../actions';
import { createConfluenceSpace } from '../actions/create-confluence-space';
import { UPDATE_PERSONALIZATION_SITE_TRAITS } from '../actions/personalization-site-traits';
import { type ActionsObservable } from 'redux-observable';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { of } from 'rxjs/observable/of';
import { shouldCreateSpaceForAutoProvisionedConfluence } from '../personalization/selectors';

export default (action$: ActionsObservable<any>, store: any) =>
	combineLatest(
		action$.ofType(UPDATE_PERSONALIZATION_SITE_TRAITS),
		action$.ofType(UPDATE_SUGGESTED_KEY),
	)
		.filter(() => shouldCreateSpaceForAutoProvisionedConfluence(store.getState()) === true)
		.switchMap(() => of(createConfluenceSpace(true)));
